import { CircularProgress, CircularProgressProps } from '@mui/material';
import React, { HTMLAttributes } from 'react';
import { useAttributeLabel } from '../../../lib/hooks/labels';
import { ATTRIBUTES } from '../../../lib/constants/attributes';
import { LOADER_LABELS } from '../../../lib/constants/labelKeys';
import { loaderIds } from '../../../lib/tests/testIds';

type LoaderProps = { containerProps?: HTMLAttributes<HTMLSpanElement> } & CircularProgressProps;

const Loader = ({ containerProps, ...rest }: LoaderProps) => {
  const loaderLabel = useAttributeLabel(ATTRIBUTES.ARIA_LABEL, LOADER_LABELS.ARIA_LABEL);

  return (
    <span {...containerProps}>
      <CircularProgress {...loaderLabel} size="100%" {...rest} data-testid={loaderIds.refreshLoader} />
    </span>
  );
};
export default Loader;
